import * as React from "react";
import { cn } from "./cn";

export type LogoProps = {
  variant?: "square" | "horizontal";
  size?: number;
  onDark?: boolean;
  className?: string;
};

export function Logo({
  variant = "horizontal",
  size = 32,
  onDark = false,
  className,
}: LogoProps) {
  const arcColor = onDark ? "#FFFFFF" : "#0F0F0F";
  const dotColor = "#32ffaa";
  const wordColor = onDark ? "#FFFFFF" : "#0F0F0F";

  const iconSvg = (
    <svg
      width={size}
      height={size}
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="shrink-0"
      aria-hidden="true"
    >
      <path
        d="M 139 61 A 55 55 0 1 0 139 139"
        stroke={arcColor}
        strokeWidth="24"
        strokeLinecap="round"
      />
      <circle cx="155" cy="100" r="16" fill={dotColor} />
    </svg>
  );

  if (variant === "square") {
    return (
      <span className={cn("inline-flex", className)} aria-label="Chốt Ca">
        {iconSvg}
      </span>
    );
  }

  return (
    <span
      className={cn("inline-flex items-center gap-[0.35em]", className)}
      aria-label="Chốt Ca"
    >
      {iconSvg}
      <span
        style={{ fontSize: Math.round(size * 0.525), color: wordColor }}
        className="font-satoshi font-black tracking-tight leading-none"
      >
        Chốt
        <span style={{ color: dotColor }}> Ca</span>
      </span>
    </span>
  );
}
